import React, { useState } from 'react';
import HubPageLayout from '../components/HubPageLayout';
import FramedPanel from '../components/FramedPanel';

const faqItems = [
  {
    question: 'What is being ScammerAware?',
    answer: 'Being ScammerAware means having the knowledge, tools, and awareness to identify and protect yourself from online fraud, scams, and digital predators. It is about understanding the tactics scammers use and making informed decisions to safeguard your personal information and finances.',
  },
  {
    question: 'What is UniScammer Design',
    answer: 'UniScammer Design is our unified approach to understanding scammer behavior patterns across different types of fraud. It maps out common techniques, psychological manipulation tactics, and operational methods used by scammers worldwide.',
  },
  {
    question: 'Dose No / SCAM protect me from viruses or my identity?',
    answer: 'No / SCAM is focused on scam awareness and behavioral assessment rather than antivirus or identity theft protection. We help you recognize and avoid scams through education, assessments, and awareness tools. For virus protection and identity monitoring, we recommend using dedicated cybersecurity software.',
  },
  {
    question: 'How does No / SCAM work against phishing emails?',
    answer: 'No / SCAM educates you on how to identify phishing emails by teaching you the common signs and tactics used by scammers. Our SCI Web Activity Zone tool can help you verify suspicious websites linked in emails, and our educational content covers the latest phishing techniques to keep you informed.',
  },
  {
    question: 'What happens when I change my browser?',
    answer: 'No / SCAM is a web-based application that works across all modern browsers. Changing your browser will not affect your account, data, or subscription. Simply log in through your new browser to continue using all features.',
  },
];

const EDiscoveryPage = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleItem = (index) => {
    setExpandedIndex(prev => prev === index ? null : index);
  };

  return (
    <HubPageLayout>
      <FramedPanel title="eDiscovery">
        <div className="px-6 pt-8 pb-6">
          <img
            src="/images/my-noscam/ediscovery-hero.jpeg"
            alt=""
            className="w-full h-[280px] object-cover"
          />
        </div>
      </FramedPanel>

      <h2 className="text-2xl font-bold text-black mt-8 mb-4">Knowledge. Awareness. Empowerment.</h2>

        {/* FAQ Accordion */}
        <div className="pl-12 pr-8 pb-8">
          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <div key={index} className="border border-gray-300 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-4 bg-white hover:bg-gray-50 flex items-center justify-between text-left transition-colors"
                >
                  <span className="text-black text-base font-medium">{item.question}</span>
                  <span className="text-black text-xl ml-4 flex-shrink-0">
                    {expandedIndex === index ? '▼' : '▶'}
                  </span>
                </button>
                {expandedIndex === index && (
                  <div className="px-6 py-4 bg-white border-t border-gray-300">
                    <p className="text-black text-base leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

    </HubPageLayout>
  );
};

export default EDiscoveryPage;
